import { render, staticRenderFns } from "./ProductExportsIndex.vue?vue&type=template&id=36227dc4"
import script from "./ProductExportsIndex.vue?vue&type=script&lang=js"
export * from "./ProductExportsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports